import { render, staticRenderFns } from "./FooterLogos.vue?vue&type=template&id=840fdda6&scoped=true&"
import script from "./FooterLogos.vue?vue&type=script&lang=js&"
export * from "./FooterLogos.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogos.vue?vue&type=style&index=0&id=840fdda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840fdda6",
  null
  
)

export default component.exports